(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["waitlist"]) return;
  try {
    
(function () {
  var box = document.querySelector('.wl-count');
  if (!box) return;
  var span = box.querySelector('.wl-count-inline');
  if (!span) return;

  var base = parseInt(box.getAttribute('data-base'), 10);
  if (isNaN(base)) base = parseInt(span.textContent.replace(/[^0-9]/g, ''), 10) || 0;

  var KEY = 'wl_joined';

  // If the success message is showing, this visitor just signed up — remember it.
  if (document.querySelector('.wl-success')) {
    try { localStorage.setItem(KEY, '1'); } catch (e) {}
  }

  var joined = false;
  try { joined = localStorage.getItem(KEY) === '1'; } catch (e) {}

  span.textContent = (joined ? base + 1 : base).toLocaleString();
})();

  } catch(e) { console.error(e); }
})();
})();
